export default function calculateScaleAndDim(width: number, height: number, innerW: number, innerH: number) {
  let w = width;
  let h = height
  if (innerH > innerW) {
    w = height;
    h = width;
  }
  let scale = innerH / h
  let ratio = innerW / innerH;
  let newWidth = ratio * h;
  let newHeight = h;
  
  return { scale, width: newWidth, height: newHeight }
}